// components/customformCabang.jsx
import React, { useEffect, forwardRef, useImperativeHandle } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Checkbox,
  InputNumber,
  Select,
  Button,
} from "antd";

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;

const CustomFormCabang = forwardRef(
  (
    {
      formColumn = [],
      selectedData = {},
      readOnly = false,
      onSubmit,
      showInternalButtons = true,
    },
    ref
  ) => {
    const [form] = Form.useForm();

    useEffect(() => {
      if (selectedData && Object.keys(selectedData).length) {
        const initial = { ...selectedData };
        if (typeof initial.is_active === "number") {
          initial.is_active = !!initial.is_active;
        }
        form.setFieldsValue(initial);
      } else {
        form.resetFields();
      }
    }, [selectedData, form]);

    useImperativeHandle(ref, () => ({
      submit: () => {
        form.submit();
      },
      getFieldsValue: () => form.getFieldsValue(),
      reset: () => form.resetFields(),
    }));

    const renderField = (f) => {
      const name = f.key;
      const common = {
        name,
        label: f.label,
        rules: f.required
          ? [{ required: true, message: `${f.label} wajib diisi` }]
          : [],
      };

      const disabled = !!readOnly;

      switch ((f.type || "text").toLowerCase()) {
        case "text":
          return (
            <Item {...common}>
              <Input placeholder={f.placeholder} disabled={disabled} />
            </Item>
          );

        case "password":
          return (
            <Item {...common}>
              <Input.Password placeholder={f.placeholder} disabled={disabled} />
            </Item>
          );

        case "number":
          return (
            <Item {...common}>
              <InputNumber
                style={{ width: "100%" }}
                placeholder={f.placeholder}
                disabled={disabled}
              />
            </Item>
          );

        case "textarea":
          return (
            <Item {...common}>
              <TextArea
                rows={4}
                placeholder={f.placeholder}
                disabled={disabled}
              />
            </Item>
          );

        case "checkbox":
          return (
            <Item
              name={name}
              valuePropName="checked"
              style={{ marginBottom: 0 }}
            >
              <Checkbox disabled={disabled}>{f.label}</Checkbox>
            </Item>
          );

        case "select":
          return (
            <Item {...common}>
              <Select disabled={disabled} placeholder={f.placeholder}>
                {(f.options || []).map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </Item>
          );

        default:
          return (
            <Item {...common}>
              <Input placeholder={f.placeholder} disabled={disabled} />
            </Item>
          );
      }
    };

    const onFinish = (values) => {
      if (onSubmit) onSubmit(values);
    };

    return (
      <Form form={form} layout="vertical" onFinish={onFinish}>
        {formColumn.map((row, rowIdx) => (
          <Row gutter={16} key={`row-${rowIdx}`}>
            {row.map((field, idx) => (
              <Col span={24} key={`${field.key}-${idx}`}>
                {renderField(field)}
              </Col>
            ))}
          </Row>
        ))}

        {/* internal submit/reset buttons — optional via showInternalButtons */}
        {!readOnly && showInternalButtons && (
          <Row style={{ marginTop: 16 }}>
            <Col span={24} style={{ textAlign: "right" }}>
              <Button
                onClick={() => form.resetFields()}
                style={{ marginRight: 8 }}
              >
                Reset
              </Button>
              <Button type="primary" onClick={() => form.submit()}>
                Submit
              </Button>
            </Col>
          </Row>
        )}
      </Form>
    );
  }
);

export default CustomFormCabang;
